import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';

/**
 * Composant de test pour vérifier la navigation entre étapes
 * Ce composant simule la navigation entre étapes sans les données réelles
 */
const ProjectStepTest = () => {
  const { projectId, stepSlug } = useParams();
  const navigate = useNavigate();

  // Étapes de test
  const testSteps = [
    { id: 'cadrage', name: 'CADRAGE DU PROJET', slug: 'cadrage' },
    { id: 'etape1', name: 'ÉTAPE 1', slug: 'etape-1' },
    { id: 'etape2', name: 'ÉTAPE 2', slug: 'etape-2' },
    { id: 'dimensions', name: 'DIMENSIONS ET PLANS', slug: 'dimensions' }
  ];

  const currentStepIndex = testSteps.findIndex(step => step.slug === stepSlug);
  const currentStep = testSteps[currentStepIndex] || testSteps[0];

  const goToStep = (stepIndex) => {
    if (stepIndex >= 0 && stepIndex < testSteps.length) {
      const step = testSteps[stepIndex];
      navigate(`/projet/${projectId}/etape/${step.slug}`);
    }
  };

  const goToPreviousStep = () => {
    if (currentStepIndex > 0) {
      goToStep(currentStepIndex - 1);
    }
  };

  const goToNextStep = () => {
    if (currentStepIndex < testSteps.length - 1) {
      goToStep(currentStepIndex + 1);
    }
  };

  return (
    <div className="container mt-4">
      <h2>Test de Navigation - Projet {projectId}</h2>
      
      {/* Navigation des étapes */}
      <div className="steps-navigation mb-4">
        <div className="d-flex justify-content-between align-items-center">
          {testSteps.map((step, index) => (
            <div
              key={step.id}
              className={`step-indicator ${index === currentStepIndex ? 'active' : ''} ${index < currentStepIndex ? 'completed' : ''}`}
              onClick={() => goToStep(index)}
              style={{
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '5px',
                cursor: 'pointer',
                backgroundColor: index === currentStepIndex ? '#007bff' : index < currentStepIndex ? '#28a745' : '#f8f9fa',
                color: index === currentStepIndex ? 'white' : 'black'
              }}
            >
              <div className="step-number">{index + 1}</div>
              <div className="step-name">{step.name}</div>
            </div>
          ))}
        </div>
      </div>

      {/* Contenu de l'étape actuelle */}
      <div className="step-content mb-4">
        <h3>Étape actuelle : {currentStep.name}</h3>
        <p>Slug : {currentStep.slug}</p>
        <p>Index : {currentStepIndex}</p>
        <p>Project ID : {projectId}</p>
      </div>

      {/* Boutons de navigation */}
      <div className="navigation-buttons">
        <div className="row">
          <div className="col-md-6">
            {currentStepIndex > 0 && (
              <button 
                className="btn btn-outline-primary"
                onClick={goToPreviousStep}
              >
                ← Étape précédente
              </button>
            )}
          </div>
          <div className="col-md-6 text-end">
            {currentStepIndex < testSteps.length - 1 && (
              <button 
                className="btn btn-primary"
                onClick={goToNextStep}
              >
                Étape suivante →
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Informations de débogage */}
      <div className="debug-info mt-4">
        <h4>Informations de débogage</h4>
        <pre>
          {JSON.stringify({
            projectId,
            stepSlug,
            currentStepIndex,
            currentStep,
            location: window.location.href
          }, null, 2)}
        </pre>
      </div>
    </div>
  );
};

export default ProjectStepTest; 